import { Route, Routes } from "react-router-dom";

import { AppLayout } from "./components/AppLayout";
import { CaregiverFormPage } from "./features/directory/CaregiverFormPage";
import { CaregiversPage } from "./features/directory/CaregiversPage";
import { ClientFormPage } from "./features/directory/ClientFormPage";
import { ClientsPage } from "./features/directory/ClientsPage";
import { AgencyDashboard } from "./features/dashboard/AgencyDashboard";
import { PlatformDashboard } from "./features/dashboard/PlatformDashboard";
import { AccountPage } from "./features/auth/AccountPage";
import { LoginPage } from "./features/auth/LoginPage";
import { NotFoundPage } from "./features/errors/NotFoundPage";
import { ProtectedRoute } from "./routes/ProtectedRoute";

import { AgenciesPage } from "./features/admin/AgenciesPage";
import { AgencyFormPage } from "./features/admin/AgencyFormPage";
import { UsersPage } from "./features/admin/UsersPage";
import { UserFormPage } from "./features/admin/UserFormPage";

import { WeeklySchedulePage } from "./features/scheduling/WeeklySchedulePage";
import { CaregiverSchedulePage } from "./features/scheduling/CaregiverSchedulePage";
import { VisitWorkspacePage } from "./features/scheduling/VisitWorkspacePage";

import { ClientCarePlansPage } from "./features/careplans/ClientCarePlansPage";
import { TemplatesListPage } from "./features/careplans/TemplatesListPage";
import { TemplateFormPage } from "./features/careplans/TemplateFormPage";
import { AuditLogsPage } from "./features/audit/AuditLogsPage";

import { RolesPermissionsPage } from "./features/settings/RolesPermissionsPage";
import { AppearancePage } from "./features/settings/AppearancePage";
import { OrgSettingsPage } from "./features/settings/OrgSettingsPage";
import { OrgUsersPage } from "./features/settings/OrgUsersPage";

import { HelpPage } from "./features/help/HelpPage";
import { DocsPage } from "./features/help/DocsPage";
import { DocsGuidePage } from "./features/help/DocsGuidePage";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route element={<ProtectedRoute agencyOnly />}>
            <Route index element={<AgencyDashboard />} />
          </Route>

          <Route element={<ProtectedRoute superuserOnly />}>
            <Route path="platform" element={<PlatformDashboard />} />
          </Route>

          <Route path="account" element={<AccountPage />} />
          <Route path="settings/appearance" element={<AppearancePage />} />
          <Route path="help" element={<HelpPage />} />
          <Route path="docs" element={<DocsPage />} />
          <Route path="docs/:slug" element={<DocsGuidePage />} />

          <Route element={<ProtectedRoute agencyOnly permission="scheduling.visits.view" />}>
            <Route path="schedule" element={<WeeklySchedulePage />} />
            <Route path="visits/:id" element={<VisitWorkspacePage />} />
          </Route>

          <Route element={<ProtectedRoute agencyOnly permission="careplans.plans.view" />}>
            <Route path="care-plans" element={<ClientCarePlansPage />} />
            <Route path="care-plans/templates" element={<TemplatesListPage />} />
            <Route path="care-plans/templates/new" element={<TemplateFormPage />} />
            <Route path="care-plans/templates/:id" element={<TemplateFormPage />} />
          </Route>

          <Route element={<ProtectedRoute permission="audit.logs.view" />}>
            <Route path="audit-logs" element={<AuditLogsPage />} />
          </Route>

          <Route element={<ProtectedRoute agencyOnly permission="organization.users.view" />}>
            <Route path="settings/users" element={<OrgUsersPage />} />
          </Route>

          <Route element={<ProtectedRoute agencyOnly permission="organization.settings.view" />}>
            <Route path="settings/org" element={<OrgSettingsPage />} />
          </Route>

          <Route element={<ProtectedRoute agencyOnly permission="directory.clients.view" />}>
            <Route path="clients" element={<ClientsPage />} />
            <Route path="clients/new" element={<ClientFormPage />} />
            <Route path="clients/:id" element={<ClientFormPage />} />
          </Route>

          <Route element={<ProtectedRoute agencyOnly permission="directory.caregivers.view" />}>
            <Route path="caregivers" element={<CaregiversPage />} />
            <Route path="caregivers/new" element={<CaregiverFormPage />} />
            <Route path="caregivers/:id" element={<CaregiverFormPage />} />
            <Route path="caregivers/:id/schedule" element={<CaregiverSchedulePage />} />
          </Route>

          {/* Admin routes, protected for superusers */}
          <Route element={<ProtectedRoute superuserOnly />}>
            <Route path="admin/agencies" element={<AgenciesPage />} />
            <Route path="admin/agencies/new" element={<AgencyFormPage />} />
            <Route path="admin/agencies/:id" element={<AgencyFormPage />} />

            <Route path="admin/users" element={<UsersPage />} />
            <Route path="admin/users/new" element={<UserFormPage />} />
            <Route path="admin/users/:id" element={<UserFormPage />} />

            <Route path="admin/roles" element={<RolesPermissionsPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
